/* Extend the existing Techoze pickers: one selected variant for both purchase
 * forms, native accelerated checkout, and server-rendered prices. No option
 * combinations or money values are derived here. */
(function () {
  'use strict';
  var pickerSelector = 'product-variant-swatch, product-variant-dropdown, product-variant-selects-stick';
  var productGallerySelector = '.product-single__photos .FeaturedImage_slick, .product-single__photos #productThumbs .thumb_slick';
  var galleryArrowsReady = false;

  function setupGalleryArrows() {
    if (galleryArrowsReady || !document.body || !document.body.classList.contains('template-product')) return;
    galleryArrowsReady = true;
    var frame = null;
    var observer = null;

    function galleryArrow(arrow) {
      return arrow && !arrow.closest('#content_quickview') && arrow.closest(productGallerySelector);
    }

    function arrowIsHidden(arrow) {
      if (!arrow.isConnected || arrow.closest('.slick-cloned, [hidden], [inert], [aria-hidden="true"]')) return true;
      var element = arrow;
      while (element && element !== document.documentElement) {
        var style = window.getComputedStyle(element);
        if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse') return true;
        element = element.parentElement;
      }
      return arrow.getClientRects().length === 0;
    }

    function arrowIsInteractive(arrow) {
      if (!galleryArrow(arrow) || arrowIsHidden(arrow)) return false;
      return !arrow.disabled && !arrow.classList.contains('slick-disabled') && !arrow.classList.contains('slick-hidden');
    }

    function decorateArrow(arrow) {
      if (!galleryArrow(arrow)) return;
      var messages = window.jmA11y && window.jmA11y.swiper || {};
      var isNext = arrow.classList.contains('arrow-next');
      var label = isNext ? messages.nextSlideMessage || 'השקופית הבאה' : messages.prevSlideMessage || 'השקופית הקודמת';
      var interactive = arrowIsInteractive(arrow);
      arrow.setAttribute('role', 'button');
      arrow.setAttribute('aria-label', label);
      arrow.setAttribute('aria-disabled', interactive ? 'false' : 'true');
      arrow.setAttribute('tabindex', interactive ? '0' : '-1');
    }

    function synchronize() {
      frame = null;
      document.querySelectorAll(productGallerySelector).forEach(function (gallery) {
        gallery.querySelectorAll('.arrow-prev, .arrow-next').forEach(decorateArrow);
      });
    }

    function queueSynchronize() {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(synchronize);
    }

    document.addEventListener('keydown', function (event) {
      var arrow = event.target.closest && event.target.closest('.arrow-prev, .arrow-next');
      if (!galleryArrow(arrow) || arrow.tagName === 'BUTTON' || arrow.tagName === 'A' || !arrowIsInteractive(arrow)) return;
      if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
      event.preventDefault();
      arrow.click();
    });

    observer = new MutationObserver(queueSynchronize);
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'inert', 'aria-hidden', 'disabled']
    });
    window.addEventListener('load', queueSynchronize);
    window.addEventListener('pageshow', queueSynchronize);
    window.addEventListener('resize', queueSynchronize, { passive: true });
    synchronize();
    [50, 250, 1000, 2500].forEach(function (delay) {
      window.setTimeout(queueSynchronize, delay);
    });
  }

  function setupQuantity(section) {
    var selector = 'form[id^="product-form-"] [data-jm-quantity-input]';
    var synchronizing = false;

    function quantityInputs() {
      return Array.from(section.querySelectorAll(selector)).filter(function (input) {
        return !input.closest('#content_quickview');
      });
    }

    function setBoundaryState(button, disabled) {
      if (!button) return;
      button.disabled = disabled;
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }

    function updateBoundaryState(input) {
      if (!input || input.closest('#content_quickview')) return;
      var controls = input.closest('.quick_view_qty');
      if (!controls) return;
      var min = Number(input.min) || 1;
      var max = input.max === '' ? Infinity : Number(input.max);
      if (!Number.isFinite(max) || max < min) max = Infinity;
      var step = Number(input.step) || 1;
      var value = Number(input.value);
      var invalid = input.disabled || !Number.isFinite(value);
      setBoundaryState(
        controls.querySelector('.quick_view-qty-minus'),
        invalid || value - step < min
      );
      setBoundaryState(
        controls.querySelector('.quick_view-qty-plus'),
        invalid || Number.isFinite(max) && value + step > max
      );
    }

    function updateAllBoundaryStates() {
      quantityInputs().forEach(updateBoundaryState);
    }

    function synchronize(source, commit) {
      if (synchronizing) return;
      if (!source || source.closest('#content_quickview')) return;
      if (source.value.trim() === '' && !commit) {
        updateBoundaryState(source);
        return;
      }
      var min = Number(source.min) || 1;
      var max = source.max === '' ? Infinity : Number(source.max);
      if (!Number.isFinite(max) || max < min) max = Infinity;
      var step = Number(source.step) || 1;
      var value = Number(source.value);
      if (!Number.isFinite(value)) value = min;
      if (commit) {
        value = Math.max(min, value);
        if (max >= min) value = Math.min(max, value);
        value = min + Math.floor((value - min) / step) * step;
      } else if (value < min || value > max || (value - min) % step !== 0) {
        updateBoundaryState(source);
        return;
      }
      synchronizing = true;
      quantityInputs().forEach(function (input) {
        if (input.value === String(value)) return;
        input.value = String(value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      synchronizing = false;
      updateAllBoundaryStates();
    }
    section.addEventListener('input', function (event) {
      if (event.target.matches(selector) && !event.target.closest('#content_quickview')) synchronize(event.target, false);
    });
    section.addEventListener('change', function (event) {
      if (event.target.matches(selector) && !event.target.closest('#content_quickview')) synchronize(event.target, true);
    });
    section.addEventListener('click', function (event) {
      var button = event.target.closest('.quick_view-qty-plus, .quick_view-qty-minus');
      if (!button || button.closest('#content_quickview') || !button.closest('form[id^="product-form-"]')) return;
      var input = button.closest('.quick_view_qty').querySelector('input[name="quantity"]');
      if (!input || input.disabled) return;
      // Techoze changes the value from a delegated document click handler.
      // Wait for that complete event turn before mirroring its final value.
      window.setTimeout(function () {
        synchronize(input, true);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }, 0);
    });
    return function () {
      var inputs = quantityInputs();
      synchronize(inputs[0], true);
      if (!inputs.length) updateAllBoundaryStates();
    };
  }

  function setup(section) {
    if (section.dataset.jmPurchaseReady) return;
    section.dataset.jmPurchaseReady = 'true';
    var syncQuantity = setupQuantity(section);
    var pickers = Array.from(section.querySelectorAll(pickerSelector));
    if (!pickers.length) {
      syncQuantity();
      return;
    }
    var main = pickers.find(function (picker) { return picker.tagName !== 'PRODUCT-VARIANT-SELECTS-STICK'; }) || pickers[0];
    var requestNumber = 0;
    var pendingRequest;
    var syncing = false;
    var isRefreshing = false;

    function purchaseForms() {
      return Array.from(section.querySelectorAll('form[id^="product-form-"]'));
    }

    function setState(variant, busy) {
      var available = !!(variant && variant.available);
      purchaseForms().forEach(function (form) {
        var id = form.querySelector('input[name="id"]');
        var nextId = variant ? String(variant.id) : '';
        if (id && id.value !== nextId) {
          id.value = nextId;
          id.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var stockOption = variant && section.querySelector('#productSelect option[value="' + variant.id + '"]');
        var managed = stockOption && stockOption.getAttribute('data-inventory_management') === 'shopify';
        var backorder = stockOption && stockOption.getAttribute('data-inventory_policy') === 'continue';
        var quantity = form.querySelector('[data-jm-quantity-input]');
        var fallbackQuantity = form.querySelector('[data-jm-quantity-fallback]');
        var hasQuantityUi = !!quantity;
        form.querySelectorAll('[data-jm-quantity-ui]').forEach(function (ui) {
          ui.hidden = !available;
          if (available) {
            ui.removeAttribute('inert');
            ui.removeAttribute('aria-hidden');
            if (ui.dataset.jmQuantityDisplayManaged === 'true') {
              ui.style.removeProperty('display');
              delete ui.dataset.jmQuantityDisplayManaged;
            }
          } else {
            ui.setAttribute('inert', '');
            ui.setAttribute('aria-hidden', 'true');
            ui.style.setProperty('display', 'none', 'important');
            ui.dataset.jmQuantityDisplayManaged = 'true';
          }
        });
        if (quantity) {
          quantity.disabled = !available;
          form.querySelectorAll('[data-jm-quantity-ui] .quick_view-qty').forEach(function (button) {
            button.disabled = !available;
          });
          if (available && managed && !backorder) {
            var min = Number(quantity.min) || 1;
            var inventory = Number(stockOption.getAttribute('data-qty'));
            if (Number.isFinite(inventory) && inventory >= min) quantity.max = String(inventory);
            else quantity.removeAttribute('max');
          } else {
            quantity.removeAttribute('max');
          }
        }
        if (fallbackQuantity) {
          fallbackQuantity.value = '1';
          // Without a rendered quantity UI the setting is off, so the fallback
          // remains the form's sole quantity field for every variant state.
          fallbackQuantity.disabled = hasQuantityUi && available;
        }
        var submit = form.querySelector('[name="add"]');
        var wrap = form.querySelector('.product-form__item--submit');
        if (submit && wrap) {
          submit.disabled = !variant || !!busy;
          submit.setAttribute('aria-busy', busy ? 'true' : 'false');
          submit.type = available ? 'submit' : 'button';
          submit.classList.toggle('product-form__cart-submit', available && submit.dataset.jmAjaxAdd === 'true');
          wrap.classList.toggle('soldout', !available);
          if (variant && !available) {
            wrap.setAttribute('data-toggle', 'modal');
            wrap.setAttribute('data-target', '#Form_newletter');
          } else {
            wrap.removeAttribute('data-toggle');
            wrap.removeAttribute('data-target');
          }
          var label = submit.querySelector('[data-jm-add-label]');
          if (label && window.variantStrings) {
            label.textContent = !variant ? window.variantStrings.unavailable : !available ? window.variantStrings.notify_me :
              managed && backorder ? window.variantStrings.preorder : window.variantStrings.addToCart;
          }
        }
        var express = form.querySelector('[data-jm-express]');
        if (express) {
          express.hidden = !available || !!busy;
          express.disabled = !available || !!busy;
        }
      });
      syncQuantity();
      section.querySelectorAll('[data-jm-reservable]').forEach(function (badge) { badge.hidden = !available; });
      // On-request products: WhatsApp and call in place of the buy button while the variant is out.
      section.querySelectorAll('[data-jm-on-request]').forEach(function (cta) { cta.hidden = available; });
      section.querySelectorAll('[data-jm-stock]').forEach(function (stock) {
        var status = stock.querySelector('.product__available');
        var label = stock.querySelector('[data-jm-stock-label]');
        if (status) {
          status.classList.toggle('in-stock', available);
          status.classList.toggle('sold-out', !available);
        }
        if (label) label.textContent = !variant && window.variantStrings ? window.variantStrings.unavailable :
          available ? stock.dataset.inStock : stock.dataset.soldOut;
        stock.querySelectorAll('[data-jm-stock-icon]').forEach(function (icon) {
          icon.hidden = (icon.dataset.jmStockIcon === 'available') !== available;
        });
      });
    }

    function mirrorOptions(source) {
      pickers.forEach(function (picker) {
        if (picker === source) return;
        var groups = picker.querySelectorAll('fieldset');
        if (groups.length) {
          groups.forEach(function (group, index) {
            var currentLabel = group.querySelector('.variant_current');
            if (currentLabel) currentLabel.textContent = source.options[index];
            group.querySelectorAll('input[type="radio"]').forEach(function (radio) {
              radio.checked = radio.value === source.options[index];
            });
          });
        } else {
          picker.querySelectorAll('select').forEach(function (select, index) { select.value = source.options[index]; });
        }
        // Resolve the mirrored inputs through Techoze's own variant selector.
        picker.updateOptions();
        picker.updateMasterId();
      });
    }

    function sync(source) {
      if (syncing) return;
      syncing = true;
      mirrorOptions(source);
      setState(source.currentVariant);
      syncing = false;
    }

    function refresh(source) {
      sync(source);
      var variant = source.currentVariant;
      var revision = ++requestNumber;
      if (pendingRequest) pendingRequest.abort();
      isRefreshing = !!variant;
      if (!variant) return;
      setState(variant, true);
      pendingRequest = new AbortController();
      var url = new URL(source.dataset.productUrl, window.location.origin);
      url.searchParams.set('variant', variant.id);
      url.searchParams.set('section_id', source.dataset.originalSection || source.dataset.productId);
      fetch(url.toString(), { signal: pendingRequest.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Product section unavailable');
          return response.text();
        })
        .then(function (html) {
          if (revision !== requestNumber) return;
          var rendered = new DOMParser().parseFromString(html, 'text/html');
          // JmBuyAssurance-: the stock and pickup line (snippets/jm-buy-assurance.liquid).
          ['ProductPrice-', 'ProductPriceStick-', 'JmBuyAssurance-'].forEach(function (prefix) {
            var id = prefix + source.dataset.productId;
            var target = section.querySelector('[id="' + id + '"]');
            var fresh = rendered.getElementById(id);
            if (target && fresh) target.innerHTML = fresh.innerHTML;
          });
          var sku = section.querySelector('#variantSku');
          var freshSku = rendered.getElementById('variantSku');
          if (sku && freshSku) sku.innerHTML = freshSku.innerHTML;
          isRefreshing = false;
          setState(variant);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          // A normal product navigation lets Shopify render the selected price
          // if a section request fails. Never leave an old price with a new ID.
          if (revision === requestNumber) {
            url.searchParams.delete('section_id');
            window.location.assign(url.toString());
          }
        });
    }

    pickers.forEach(function (picker) {
      // The original onVariantChange owns selection, media, pickup and URL.
      // Replace only its unguarded price fetch: it updates just one form and
      // accepts older responses after a newer selection has already completed.
      picker.renderProductInfo = function () { refresh(picker); };
      picker.setUnavailable = function () { sync(picker); };
      picker.addEventListener('change', function (event) {
        if (event.target.matches('input[type="radio"], select') && !picker.currentVariant) {
          ++requestNumber;
          isRefreshing = false;
          if (pendingRequest) pendingRequest.abort();
          sync(picker);
        }
      });
    });

    section.addEventListener('submit', function (event) {
      if (!event.target.matches('form[id^="product-form-"]')) return;
      if (isRefreshing || !main.currentVariant || !main.currentVariant.available) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    main.updateOptions();
    main.updateMasterId();
    sync(main);
  }

  function init(scope) {
    setupGalleryArrows();
    scope.querySelectorAll('.shopify-section').forEach(function (section) {
      var pickers = Array.from(section.querySelectorAll(pickerSelector));
      if (!section.querySelector('form[id^="product-form-"]')) return;
      Promise.all(pickers.map(function (picker) { return customElements.whenDefined(picker.localName); }))
        .then(function () { setup(section); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function () { init(document); });
})();
